import { createContext } from 'react';

export interface User {
  id: string;
  email: string;
  nom: string;
  prenom: string;
  role?: 'admin' | 'superviseur' | 'user' | 'aas_admin' | 'aas_user' | 'mairie_admin' | 'mairie_user' | 'ssbc_admin' | 'ssbc_user' | 'doc_admin' | 'doc_pm' | 'doc_agent';
}

export interface AuthContextType {
  user: User | null;
  loading: boolean;
  login: (email: string, password: string, rememberMe?: boolean) => Promise<{ success: boolean; mustChangePassword?: boolean; error?: string }>;
  logout: () => Promise<void>;
  changePassword: (newPassword: string) => Promise<{ success: boolean; error?: string }>;
  authorizedApps: string[];
  favorites: string[];
  toggleFavorite: (appSlug: string) => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
